import React, { useRef, useState } from "react";
import {
  Container,
  Box,
  LinearProgress,
  Typography,
  Slide,
} from "@mui/material";

// Interstitial "authentication in progress" page
export const AuthenticationInProgressPage = () => {
  const containerRef = useRef(null);
  const [loading, setLoading] = useState(false);
  return (
    <Container maxWidth="xs" ref={containerRef}>
      <Slide
        direction="up"
        timeout={300}
        in={true}
        container={containerRef.current}
        onEntered={() =>
          setTimeout(() => {
            setLoading(true);
          }, 300)
        }
      >
        <Box>
          <Typography variant="h2" gutterBottom>
            Signing in ...
          </Typography>
          {loading && <LinearProgress />}
        </Box>
      </Slide>
    </Container>
  );
};
